import { createSlice } from '@reduxjs/toolkit';
import { Transaction } from '@/api/general';

export interface ILinkPaymentState {
    isPending: boolean;
    isLinkModalOpen: boolean;
    transactionToDisplay: Transaction | null;
}

const initialState: ILinkPaymentState = {
    isPending: false,
    isLinkModalOpen: false,
    transactionToDisplay: null,
};

export const linkPaymentSlice = createSlice({
    name: 'linkPayment',
    initialState,
    reducers: {
        showLinkPaymentModal: (state, action) => {
            state.isLinkModalOpen = true;
            state.transactionToDisplay = action.payload;
        },
        closeLinkPaymentModal: (state) => {
            state.isLinkModalOpen = false;
        },
    },
});

export const { showLinkPaymentModal, closeLinkPaymentModal } = linkPaymentSlice.actions;

export default linkPaymentSlice.reducer;
